/**
 * Authors: mariushirjanu
 * Created: 05/08/2021
 */
import { NgModule } from '@angular/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { UIRouterModule } from '@uirouter/angular';
import { SharedModule } from '@app/shared/shared.module';
import { CommonModule } from '@angular/common';
import { OrderFeesComponent } from './order-fees/order-fees.component';
import { STATE_INVOICE, STATE_INVOICE_ORDERFEES } from '@app/shared/app-states';
import { Transition } from '@uirouter/angular';
import { InvoiceComponent } from './invoice.component';
import { OrderFeesDataService } from './order-fees/order-fees-data.service';
import { IncludedOrdersDialogComponent } from './order-fees/included-orders-dialog.component';
import { RejectProformaDialogComponent } from './order-fees/reject-proforma-dialog.component';
import { ConfirmProformaDialogComponent } from './order-fees/confirm-proforma-dialog.component';
import { ConfirmPaymentDialogComponent } from './order-fees/confirm-payment-dialog.component';
import { TranslationCategory } from '@app/shared/services/ga-state.service';
import { GaStateDeclaration } from '@type_definitions/datatypes';
import { TRANSLATION_READY_RESOLVER } from '@app/app-routes.config';

const states:GaStateDeclaration[] = [
  {
    name: STATE_INVOICE,
    url: '/invoice/{invoiceId}',
    abstract: true,
    views: {
      content: {
        component: InvoiceComponent
      }
    },
    resolve: [
      {
        token: 'invoiceId',
        deps: [ Transition ],
        resolveFn: (trans:Transition) => Number(trans.params().invoiceId)
      }
    ],
    data: {
      translate: true,
      modules: [ TranslationCategory.INVOICE, TranslationCategory.ORDERENTRY ] // load invoice & orderentry translation keys
    }
  },
  {
    name: STATE_INVOICE_ORDERFEES,
    url: '/orderfees',
    component: OrderFeesComponent,
    data: {
      viewTitle: 'Order fee invoice'
    },
    resolve: [TRANSLATION_READY_RESOLVER]
  }
];

@NgModule({
  imports: [
    UIRouterModule.forChild({ states }),
    CommonModule,
    SharedModule,
    BsDropdownModule
  ],
  declarations: [
    InvoiceComponent,
    OrderFeesComponent,
    IncludedOrdersDialogComponent,
    ConfirmProformaDialogComponent,
    ConfirmPaymentDialogComponent,
    RejectProformaDialogComponent
  ],
  providers: [
    OrderFeesDataService
  ]
})
export class InvoiceModule {
}